<template>
	<div class="full" style="background-color: white;">
		<el-container class="full">
			<el-aside width="250px" style="border-right: 1px solid #DCDFE6;">
				<emun-tree :field="name" ref="emuntTree" :key="emuntTreeKey" @select="emuntTreeChange" />
			</el-aside>
			<el-container class="full flex"
				style="position: relative;flex-direction: column;box-sizing: border-box;padding: 20px;">
				<el-header class="bread" style="position: relative;height: 30px;">
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item v-for="(item,index) in parentbread" :key="index">{{item.name}}
						</el-breadcrumb-item>
					</el-breadcrumb>
				</el-header>
				<el-main style="flex: 1;position: relative;">
					<el-tabs class="full flex" style="flex-direction: column;" v-model="activeName" type="card">
						<el-tab-pane label="基本信息" name="baseinfo">
							<div class="pane_container">
								<baseinfo v-if="currentitem && currentitem.children.length==0" :name="name" :emunid="emunid" />
							</div>
						</el-tab-pane>
						<el-tab-pane label="材质属性" name="attribute">
							<div class="pane_container">
								<attribute v-if="currentitem && currentitem.children.length==0" :name="name" :emunid="emunid" />
							</div>
						</el-tab-pane>
					</el-tabs>
				</el-main>
			</el-container>
		</el-container>

	</div>

</template>
<style scoped>
	.bread {
		flex-direction: column;
		align-items: center;
		justify-content: center;

	}
</style>
<script>
	import emunTree from '@_system/components/formcomponents/common/select/emun/tree.vue'
	import baseinfo from './baseinfo.vue'
	import attribute from './attribute.vue'
	export default {
		name: 'emunextend_goodstypeIndex',
		props: {
			name: {
				default: () => {
					return ''
				}
			},
		},
		data() {
			return {
				activeName: 'baseinfo',
				emuntTreeKey: Math.random(),
				key: Math.random(),
				parentbread: [],
				emunid:0,
				currentitem:null
			}
		},
		watch: {

		},
		created() {

		},
		mounted() {

		},
		computed: {

		},

		methods: {
			onSubmit() {
				console.log('submit!');
			},
			inittab() {
				this.key = Math.random()
			},
			emuntTreeChange(e) {
				this.currentitem = e
				this.emunid = e.id
				this.parentbread = e.parentbread
			},
		},
		components: {
			emunTree,
			baseinfo,
			attribute
		}
	}
</script>